/** One Seed Indent (docs/designs/mtn-seed-indent.md, Phase 3). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { Callout } from "@/components/ui/callout";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { errMsg, useIndent } from "@/features/seed-indent/hooks";
import { IndentPage } from "@/features/seed-indent/indent-page";

export const Route = createFileRoute("/_app/packaging/seed-indents/$id")({
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  const q = useIndent(Number(id));
  const { facilities } = useFacilities();
  if (q.isPending) return <FormPageSkeleton />;
  if (q.isError)
    return (
      <Callout tone="danger" title="Could not load the indent">
        {errMsg(q.error)}
      </Callout>
    );
  const plant = facilities.find((f) => f.id === q.data.facilityId);
  return (
    <IndentPage
      key={`${q.data.id}-${q.data.version}`}
      indent={q.data}
      plantName={plant ? `${plant.name} (${plant.plantCode})` : null}
    />
  );
}
